// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"f3f0973a","224":"6fae50d3","266":"ea96984a","422":"4aeee205","628":"66afe0a1","654":"421d867e","811":"60439353","948":"93a39b2e","963":"274ddc6c"}[chunkId] + ".css";
};